export default "__VITE_ASSET__BsQrs$gX__"